import { Component } from '@angular/core';
import { NbLayoutModule, NbSidebarModule } from '@nebular/theme';
import { HeaderComponent, FooterComponent } from '../../components';
import { KPHeaderData } from '@res/ngg-core';

@Component({
  standalone: true,
  selector: 'nggt-three-columns-layout',
  styleUrls: ['./three-columns.layout.scss'],
  imports: [NbLayoutModule, NbSidebarModule, HeaderComponent, FooterComponent],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <nggt-header [headerData]="data"></nggt-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="small"> </nb-layout-column>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-column class="small"> </nb-layout-column>

      <nb-layout-footer fixed>
        <nggt-footer></nggt-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class ThreeColumnsLayoutComponent {
  protected data: KPHeaderData = {
    headerBrandTitle: 'REPELACEME',
    // Add the required data structure for headerData here
  };
}
